import { Injectable } from "@angular/core";
import { BaseCrudService } from "../../../core/data/services/base-crud.service";
import PaymentTokenResponse from "../../../core/data/dtos/payment.token.response";
import PaymentTokenRequest from "../../../core/data/dtos/payment.token.request";

@Injectable()
export class PaymentTokenService extends BaseCrudService<PaymentTokenResponse> {
    controller = 'connect';    

    createToken = (request: PaymentTokenRequest) => {
        return this.create(request, 'token')
    }
    
}